import React from "react";
import { Flex } from "./FlexHelpers";
import { ReferenceFilesModalButton } from "./ReferenceFilesModal";
import { ReferenceLinksModalButton } from "./ReferenceLinksModal";
import { CommentDrawerButton } from "./CommentsDrawer";
import { FileReference, LinkReference, CommentReference } from "../../amorg-common";

export function FileLinkCommentsButtonRow(props: { 
    fileReference?:FileReference,
    linkReference?:LinkReference,
    commentReference?: CommentReference,
    disabled?: boolean,
}) {
    return (
        <Flex gap={8} justifyContent="space-between" flexWrap="wrap">
            <Flex gap={4} flexGrow='1' flexWrap="wrap">
                {props.fileReference &&
                    <ReferenceFilesModalButton
                        fileReference={props.fileReference}
                        disabled={props.disabled}
                    />
                }

                {props.linkReference &&
                    <ReferenceLinksModalButton
                        linkReference={props.linkReference}
                        disabled={props.disabled}
                    />
                }
            </Flex>

            {props.commentReference && 
                <Flex justifyContent="flex-end">
                    <CommentDrawerButton 
                        reference={props.commentReference}
                        disabled={props.disabled}
                    />
                </Flex> 
            }
        </Flex>
    );
}